import React, { useState } from "react";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { useStore } from "../context/StoreContext";
import api from "../lib/api";
import { MEDIA } from "../lib/media";
import { toast } from "sonner";

export default function Contact() {
  const { settings } = useStore();
  const [f, setF] = useState({ name: "", email: "", phone: "", message: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/contact", f); toast.success(r.data.message); setF({ name: "", email: "", phone: "", message: "" }); }
    catch { toast.error("Could not send message"); }
  };
  return (
    <div>
      <section className="relative h-[40vh] min-h-[280px] flex items-end overflow-hidden">
        <img src={MEDIA.fern} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/45" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 pb-12 text-ivory"><span className="eyebrow text-ivory/80">Contact</span><h1 className="serif text-5xl lg:text-6xl mt-2">Come say hello.</h1></div>
      </section>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 grid lg:grid-cols-2 gap-16">
        <div className="space-y-8">
          <p className="text-forest/70 leading-relaxed max-w-md">We'd love to hear from you — questions about products, orders, or simply to share your ritual.</p>
          <div className="space-y-5">
            <div className="flex items-center gap-4"><Mail size={18} className="text-moss" /><span>{settings.contact_email || "hello@iah.com"}</span></div>
            <div className="flex items-center gap-4"><Phone size={18} className="text-moss" /><span>{settings.contact_phone || "+91 98000 00000"}</span></div>
            <div className="flex items-center gap-4"><MapPin size={18} className="text-moss" /><span>{settings.contact_address || "Shillong, Meghalaya, India"}</span></div>
            <div className="flex items-center gap-4"><Clock size={18} className="text-moss" /><span>{settings.support_hours || "Mon–Sat, 10am – 6pm IST"}</span></div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-5 bg-beige/40 p-8">
          <input className="input-line" placeholder="Name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="contact-name" />
          <input className="input-line" type="email" placeholder="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="contact-email" />
          <input className="input-line" placeholder="Phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="contact-phone" />
          <textarea className="input-line resize-none" rows={5} placeholder="Message" required value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="contact-message" />
          <button className="btn-primary w-full" data-testid="contact-submit">Send Message</button>
        </form>
      </div>
    </div>
  );
}
